import { isPartOfViewport } from "../../../resources/js/helper/helper";

(function () {
  const parallax = document.querySelectorAll(".mb-parallax"),
    speed = 0.3;

  if (parallax.length > 0) {
    document.addEventListener(
      "scroll",
      function (e) {
        const windowInnherHeight =
          window.innerHeight || document.documentElement.clientHeight;

        for (let i = 0; i < parallax.length; i++) {
          const el = parallax[i];
          if (isPartOfViewport(el)) {
            const parallaxImage = el.querySelector(".parallax");
            const bounding = el.getBoundingClientRect();
            const heightRatioMultiplicator =
              bounding.height / windowInnherHeight;
            const translateY =
              (windowInnherHeight - bounding.top) *
              heightRatioMultiplicator *
              speed;

            parallaxImage.style.transform =
              "translate3d(0, -" + translateY + "px, 0)";
          }
        }
      },
      { passive: false }
    );
  }
})();
